import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { CSSObject } from '@emotion/react';

interface ImageProps {
  src: string;
  style?: CSSObject;
  testID?: string;
  alt?: string;
  ariaHidden?: boolean;
  onError?: (errors) => void;
}

type CombinedProps = ImageProps & Omit<React.ComponentProps<'img'>, 'style'>;

/**
 * @deprecated Use 'next/image' instead. See /docs/images.md for more information.
 */
function Image({ src, style, testID, alt, ariaHidden, onError, ...rest }: CombinedProps): JSX.Element {
  return (
    <img
      src={src}
      css={style}
      alt={alt}
      onError={onError}
      {...injectTestId(testID)}
      {...(ariaHidden && { 'aria-hidden': true })}
      {...rest}
    />
  );
}

export default Image;
